import { render, staticRenderFns } from "./EtapaIdentificacao.vue?vue&type=template&id=458b77f4&scoped=true"
import script from "./EtapaIdentificacao.vue?vue&type=script&lang=js"
export * from "./EtapaIdentificacao.vue?vue&type=script&lang=js"
import style0 from "./EtapaIdentificacao.vue?vue&type=style&index=0&id=458b77f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b77f4",
  null
  
)

export default component.exports